const RESERVED_SLUGS = new Set([
  "www", "api", "admin", "app", "auth", "static", "assets", "cdn",
  "billing", "docs", "support", "pos", "status", "mail", "dev", "staging",
])

/** Server / SSR fallback (not used in browser bundle for tenant UI). */
export function resolveServerApiBaseUrl(): string {
  return (
    process.env.BACKEND_INTERNAL_URL ||
    process.env.BACKEND_URL ||
    process.env.VITE_BACKEND_URL ||
    "http://localhost:4000"
  )
}

/** Production API. Browser calls Railway directly; Cloudflare/Vercel only serve the SPA. */
export const PRODUCTION_API_BASE = "https://api.ibtpro.com"

export function isLocalShopHost(hostname: string | undefined): boolean {
  const host = (hostname ?? "").toLowerCase()
  return host === "localhost" || host === "127.0.0.1"
}

/**
 * Browser API base URL.
 * - Dev (`npm run dev`): `""` → Vite proxies `/api` to the local backend.
 * - Packed shop (`localhost` / `127.0.0.1`): `""` → serve.cjs proxies `/api` to the local API.
 * - Hosted production: `https://api.ibtpro.com`.
 */
export function resolveBrowserApiBaseUrl(): string {
  if (import.meta.env.DEV) return ""
  if (typeof window !== "undefined" && isLocalShopHost(window.location.hostname)) return ""
  return PRODUCTION_API_BASE
}

export function usesDirectBackendApi(): boolean {
  return Boolean(resolveBrowserApiBaseUrl())
}

export function apiUrl(path: string): string {
  const base = resolveBrowserApiBaseUrl()
  if (!base) return path.startsWith("/") ? path : `/${path}`
  const suffix = path.startsWith("/") ? path : `/${path}`
  return `${base}${suffix}`
}

export function resolveTenantSlugFromHost(): string | null {
  if (typeof window === "undefined") return null
  const rootDomain = (import.meta.env.VITE_ROOT_DOMAIN || "ibtpro.com")
    .toLowerCase()
    .replace(/:\d+$/, "")
  const hostnameOnly = window.location.hostname.toLowerCase()

  if (hostnameOnly.endsWith(`.${rootDomain}`)) {
    const candidate = hostnameOnly.slice(0, -(rootDomain.length + 1)).split(".")[0]
    if (candidate && !RESERVED_SLUGS.has(candidate)) return candidate
  }
  if (hostnameOnly.endsWith(".localhost")) {
    const candidate = hostnameOnly.slice(0, -".localhost".length).split(".")[0]
    if (candidate && !RESERVED_SLUGS.has(candidate)) return candidate
  }
  return null
}
